<ion-tabs>
  <ion-tab-bar slot="bottom" color="primary">
    <ion-tab-button tab="tab1" href="/tabs/tab1">
      <ion-icon name="id-card"></ion-icon>
      <ion-label>{{'TABS.myCard' | translate}}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="tab4" href="/tabs/tab4">
      <ion-icon name="qr-code-outline"></ion-icon>
      <ion-label>{{'TABS.solloCard' | translate}}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="tab2" href="/tabs/tab2">
      <ion-icon name="people-circle"></ion-icon>
      <ion-label>{{'TABS.contacts' | translate}}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="tab3" href="/tabs/tab3">
      <ion-icon name="cog"></ion-icon>
      <ion-label>{{'TABS.settings' | translate}}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
